import React from "react";
import translate from "../../../translations/translations.wrapper.jsx";
import "./datatooltip.scss";
import "./draftActionlessComments.scss";
import {useSelector} from "react-redux";
import * as reduxSelectors from "../../../store/application.reducers";
import CommentsList from "components/taskdetails-remake/panels/draftcomments/CommentsList.component";
import {DraftCommentsPanelProps} from "types/comments";
import CommentsProfile from "components/taskdetails-remake/panels/draftcomments/CommentsProfile.component";
import CommentsValidation from "components/taskdetails-remake/panels/draftcomments/CommentsValidation.component";
import { COMMENT_SAVING_STATUS, COMMENTS_INPUT_MAX_LENGTH } from "utils/constants";
import { TextArea } from "components/common/TextArea.component";
import { Button, ButtonType } from "components/common/Button.component";

const CommentsPanel: React.FC<DraftCommentsPanelProps> = (props) => {

    const comment = useSelector(reduxSelectors.getTaskDraftCommentText);
    const currentUser = useSelector(reduxSelectors.getUsersLoggedInData);
    const isInputInvalid = comment?.length > COMMENTS_INPUT_MAX_LENGTH;
    const savingStatus = useSelector(reduxSelectors.getTaskDraftCommentsSavingStatus);
    const commentsCount = useSelector(reduxSelectors.getTaskDraftCommentsCount);
    const isLoading = useSelector(reduxSelectors.getTaskDraftCommentsLoadingStatus);

    const isAddCommentDisabled = () => {
        return !comment ||
            savingStatus === COMMENT_SAVING_STATUS.START ||
            savingStatus === COMMENT_SAVING_STATUS.SAVING ||
            comment?.length > 500 ||
            comment?.length === 0;
    };

    const currentCommentsCount = () => {
        if (props.allowExtraComments)
            return isLoading ? 0 : commentsCount;
        return props.initialCommentsCount ? props.initialCommentsCount : 0;
    };

    return (
        <div className="d-flex align-items-stretch flex-column h-100" data-cy="taskDetail.commentsPanel">
            <div className="grid-panel-header">
                <strong>
                    {props.translate("taskDetail.comments")}
                    <span
                        className="mx-2 ga-badge ga-badge--text ga-badge--default"
                        data-cy="taskDetail.comments.number"> {currentCommentsCount() <= 999 ? currentCommentsCount() : "999+"}</span>
                </strong>
            </div>

            <CommentsList readOnly={props.readOnly}/>
            {   !(props.readOnly) &&
                <div className=" d-flex flex-column mt-auto py-16 pr-24 pl-0 ">
                    <div className="d-flex flex-row align-items-start">
                        <div>
                            <CommentsProfile
                                connectUserId={currentUser.connectUserId}
                                userName={currentUser.fullName} />
                        </div>
                        <div
                            className="d-flex flex-column w-100 ml-16 flex-grow-1 align-self-stretch gap-8">
                            <TextArea
                                id="draftCommentInput"
                                value={comment ? comment : ""}
                                placeholder={props.translate("taskDetail.addCommentPlaceholder")}
                                isDisabled={props.offline}
                                isInvalid={isInputInvalid}
                                onChange={props.onChange}
                                data-cy="taskDetail.comments.input"
                            />
                            <CommentsValidation
                                comment={comment}
                                offline={props.offline}
                                savingStatus={savingStatus}
                                translate={props.translate}
                            />
                            {props.allowExtraComments && <div className="d-flex justify-content-end ml-auto"
                                                              data-testid={"addBtn"}>
                                <Button
                                    type={ButtonType.SECONDARY}
                                    onClick={props.onSaveComment}
                                    disabled={isAddCommentDisabled()}
                                    dataCy={"taskDetail.comments.saveButton"}
                                    text={props.translate("taskDetail.sendNewComment")}
                                />
                            </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

const withTranslations = translate(CommentsPanel);

export default withTranslations;